/*
 * @Author: gujianghua
 * @Date:   2018-07-21 18:00:58
 * @Last Modified by:   gujianghua
 * @Last Modified time: 2018-08-09 11:48:30
 */

//老java后台移值，暂无swagger
import {
  service
} from '@/utils/request'

export default {
  //分页获取静态页面列表
  getStaticPageList: (data) => {
    return service({
      url: '/cloud/bbs/v1/appPage/list',
      method: 'post',
      data: data
    })
  },
  //删除
  deletStaticPage: (params) => {
    return service({
      url: '/cloud/bbs/v1/appPage/del',
      method: 'post',
      params: params
    })
  },
  //增加
  addApi: (data) => {
    return service({
      url: '/cloud/bbs/v1/appPage/add',
      method: 'post',
      data: data
    })
  },
  //获取详情
  getDetailApi: (path) => {
    return service({
      url: '/cloud/bbs/v1/appPage/find' + path,
      method: 'get',
    })
  },
  //修改
  editApi: (data) => {
    return service({
      url: '/cloud/bbs/v1/appPage/modify',
      method: 'post',
      data: data
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/contentManage/staticPageManage.js